export enum DataScopesEnum {
  EUDAMED = 'EUDAMED',
  SWISSDAMED = 'Swissdamed',
  CHINA = 'China-UDI',
  SKOREA = 'SouthKorea-UDI',
  US = 'US-UDI',
  SA = 'SaudiArabia-UDI',
  AU = "Australia-UDI",
  BRAZIL = "Brazil-UDI"
}
